module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp2_9005.81e59613.png";